export function createRoutes() {
  return [
    {
      path: 'issues',
      name: 'issues',
      component: () => import(/* webpackChunkName: "issues" */ '@/issues/IssuesChrome.vue'),
      children: [
        {
          path: '/',
          redirect: 'summary',
        },
        {
          path: 'summary',
          name: 'issuesSummary',
          component: () => import(/* webpackChunkName: "issuesSummary" */ '@/issues/IssuesSummary.vue'),
        },
        {
          path: 'list',
          name: 'issuesList',
          component: () => import(/* webpackChunkName: "issuesList" */ '@/issues/IssuesList.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
